import React, { useState } from 'react'
import dayjs from 'dayjs'
import { withStyles } from '@material-ui/core/styles'
import { Button, Dialog, DialogContent, CardMedia, Grid, Typography, Card } from '@material-ui/core'
import { FiberManualRecord } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import giftList from '../cabinet/shop/giftList'

const styles = theme => ({
  button: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 0,
    marginTop: 20
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'row'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginHorizontal: 5,
    alignItems: 'center',
    paddingBottom: 5,
    position: 'relative'
  },
  bottomCardBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  amount: {
    position: 'absolute',
    right: 5
  }
})

const GiveGiftDialog = ({ classes, onClose, open, myGifts, giveGift }) => {
  const { t } = useTranslation()
  if (!myGifts) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} className={classes.dialog}>
      <DialogContent className={classes.dialogContent}>
        {
          myGifts.map(item => {           
            const { image, price } = giftList.find(g => g.id === item.id)
            const { amount } = item
            if (amount === 0) return null
            return (
              <Card item key={item.id} className={classes.card}>
                <Typography className={classes.amount}>
                  {item.amount}
                </Typography>
                <img className={classes.img}
                  alt=''
                  src={image} />
                <div className={classes.bottomCardBlock}>
                  <Typography color='textSecondary'>
                    {`$${price}`}
                  </Typography>
                  <Button
                    size="small"
                    variant='contained'
                    color='primary'
                    onClick={() => giveGift(item.id)}
                  >
                    {t('TopBar:gift')}
                  </Button>
                </div>
              </Card>
            )
          })
        }
      </DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(GiveGiftDialog)
